

import UMUM from "../../library/umum.js";
export default {
  data() {
    return {
      UMUM: UMUM,
      btn_add: false,
      mdl_add: false,
      mdl_edit: false,
      mdl_delete: false,
      alert: false,
      mdl_lihat: false,
      selectedItem: {},
      cari_value: "",
      page_first: 1,
      page_last: 1,
      page_limit: 9,
      total: 0,
      mdlAmbil: false,
      selectedProgram: {},
      jumlahAmbil: 0,
      ambilSemua: false,
      catatanAmbil: '',

      tipe: null, // simpan tipe user

      editorToolbar: [
        ['bold', 'italic', 'underline'],
        ['link', 'quote', 'unordered', 'ordered'],
        ['left', 'center', 'right', 'justify'], // ✅ rata teks
        ['image'], // ✅ upload / insert gambar
        ['viewsource']
      ],


      form: {
        bidang_csr_id: null,
        bidang_sub_csr_id: null,
        nama_csr: "",
        deskripsi: "",
        jumlah: "",
        satuan: "",
        nilai: "",
        tanggal_mulai: "",
        tanggal_selesai: "",
        kecamatan_id: "",
        desa_id: "",
        alamat: "",
        file_name: null,   // (lama)
        file: null,        // (lama, lampiran gambar/foto)
        file_spec: null    // 🔥 BARU: lampiran spesifikasi (PDF)
      },

      mitra: {
        nama_perusahaan: '',
        email_perusahaan: '',
        telp_perusahaan: '',
        alamat_perusahaan: '',
        nama_pj: '',
        jabatan: '',
        email_pj: '',
        hp_pj: ''
      },
      list_bidang: [],
      list_sub_bidang: [],
      list_kecamatan: [],
      list_kecamatan_master: [], // simpan data asli
      list_desa: [],
      list_desa_master: [],
      listCSR: [],
      file_path: this.$store.state.url.URL_APP + "uploads/",


      filterku: {
        kecamatan_id: "",
        desa_id: "",
        bidang_csr_id: "",
        bidang_sub_csr_id: "",
        status: ""
      },


      list_sub_bidang_filter: [],

      // hasil data yang difilter
      dataView: [],

      list_desa_filter: [],

      statusOptions: [
        { label: 'Semua Status', value: '' },
        { label: 'Program CSR Baru', value: 1 },
        { label: 'Dalam Pengerjaan', value: 2 },
        { label: 'Pengerjaan Sebagian', value: 3 },
        { label: 'Selesai', value: 4 }
      ],

      kecamatanOptions: [],
      bidangOptions: [] // <- ubah dari computed ke data

    }


  },


  methods: {

    ambilProgram(item) {
      this.selectedProgram = item
      this.ambilSemua = false
      this.jumlahAmbil = item.jumlah_sisa
      this.catatanAmbil = `Kami akan mengambil program CSR ${item.nama_csr}, mohon untuk segera ditindaklanjuti. Terima kasih.`
      this.mdlAmbil = true

      const profile = JSON.parse(localStorage.profile)
      const userId = profile._id
      this.getMitra(userId)
    },
    onToggleSemua(val) {
      if (val) {
        this.jumlahAmbil = this.selectedProgram.jumlah_sisa
      }
    },

    onChangeDesa(val) {
      this.filterku.desa_id = val;
      this.getView();
    },

    onStatusChange(val) {
      this.getView()
    },


    onChangeBidang(val) {
      this.filterku.bidang_sub_csr_id = "";
      this.getSubBidangFilter(val);
      this.getView();
    },

    formatRupiah(value) {
      if (value == null) return "-";
      return new Intl.NumberFormat('id-ID', {
        style: 'currency',
        currency: 'IDR',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(value);
    },

    onItemClick(item, action) {
      this.selectedItem = item;

      if (action === "edit") {
        this.openEditModal(item);
      } else if (action === "lihat") {
        this.mdl_lihat = true;
      } else if (action === "delete") {
        this.form.id = item.id;
        this.mdl_delete = true;
      }

    },


    formatDateForInput(raw) {
      if (!raw) return "";
      const s = String(raw);
      if (/^\d{4}-\d{2}-\d{2}$/.test(s)) return s;
      const d = new Date(s);
      if (isNaN(d)) return s.slice(0, 10);
      const ms = d.getTime() - d.getTimezoneOffset() * 60000;
      return new Date(ms).toISOString().slice(0, 10);
    },


    downloadFile(fileName) {
      if (fileName) {
        window.open(this.file_path + fileName, "_blank");
      }
    },

    getBidang() {
      fetch(this.$store.state.url.URL_DM_BID + "bidang", {
        headers: {
          authorization: "kikensbatara " + localStorage.token
        }
      })
        .then(res => res.json())
        .then(res_data => {
          this.list_bidang = res_data
        })
    },
    getMitra(userId) {
      fetch(this.$store.state.url.KEGIATAN_CSR + "mitra/" + userId, {
        method: "GET",
        headers: {
          authorization: "kikensbatara " + localStorage.token
        }
      })
        .then(res => res.json())
        .then(res_data => {
          if (res_data.success) {
            this.mitra = res_data.data
          } else {
            this.Notify("Gagal mengambil data mitra", "negative", "error_outline")
          }
        })
        .catch(err => {
          console.error("❌ Error:", err)
          this.Notify("Terjadi kesalahan server", "negative", "error_outline")
        })
    },

    submitAmbil() {
      if (!this.jumlahAmbil || this.jumlahAmbil <= 0) {
        this.Notify("Jumlah yang diambil harus lebih dari 0", "negative", "error_outline");
        return;
      }

      const profile = JSON.parse(localStorage.profile);

      const payload = {
        kegiatan_id: this.selectedProgram.id,
        perusahaan_id: profile._id, // ambil user login
        jumlah_ambil: this.jumlahAmbil,
        catatan_mitra: this.catatanAmbil
      };

      fetch(this.$store.state.url.KEGIATAN_CSR + "addPengajuan", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: "kikensbatara " + localStorage.token
        },
        body: JSON.stringify(payload)
      })
        .then(res => res.json())
        .then(res_data => {
          if (res_data.success) {
            this.Notify("Pengajuan berhasil dikirim", "primary", "check_circle_outline");
            this.mdlAmbil = false;
            this.getView();
          } else {
            this.Notify("Gagal mengirim pengajuan", "negative", "error_outline");
          }
        })
        .catch(err => {
          console.error("❌ Error:", err);
          this.Notify("Terjadi kesalahan server", "negative", "error_outline");
        });
    },


    async getSubBidang(presetId) {

      this.form.bidang_sub_csr_id = null;
      this.list_sub_bidang = [];


      if (!this.form.bidang_csr_id) return;

      const res = await fetch(this.$store.state.url.URL_DM_BID + "sub_bidang", {
        method: "POST",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
        },
        body: JSON.stringify({ bidang_csr_id: this.form.bidang_csr_id })
      });

      const rows = await res.json();


      this.list_sub_bidang = (rows || []).map(sb => ({
        ...sb,
        id: String(sb.id)
      }));


      if (presetId != null) {
        const val = String(presetId);
        if (this.list_sub_bidang.some(sb => sb.id === val)) {
          this.form.bidang_sub_csr_id = val;
        }
      }

    },

    getKecamatan() {
      fetch(this.$store.state.url.KEGIATAN_CSR + "kecamatan", {
        method: "GET",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
        }
      })
        .then(res => res.json())
        .then(res_data => {
          this.list_kecamatan = res_data.map(k => ({
            ...k,
            kecamatan_id: String(k.kecamatan_id)
          }));
          this.list_kecamatan_master = this.list_kecamatan;
        })
    },

    filterKecamatan(val, update) {
      if (val === '') {
        update(() => {
          this.list_kecamatan = this.list_kecamatan_master
        })
        return
      }

      update(() => {
        const needle = val.toLowerCase()
        this.list_kecamatan = this.list_kecamatan_master.filter(v =>
          v.nama_kecamatan.toLowerCase().includes(needle)
        )
      })
    },

    getDesa() {
      this.form.desa_id = ""
      this.list_desa = []
      this.list_desa_master = []

      fetch(this.$store.state.url.KEGIATAN_CSR + "desa", {
        method: "POST",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
        },
        body: JSON.stringify({
          kecamatan_id: this.form.kecamatan_id
        })
      })
        .then(res => res.json())
        .then(res_data => {
          // paksa id -> string
          this.list_desa = res_data.map(d => ({
            ...d,
            des_kel_id: String(d.des_kel_id)
          }));
          this.list_desa_master = this.list_desa;
        });
    },

    filterDesa(val, update) {
      if (val === '') {
        update(() => {
          this.list_desa = this.list_desa_master
        })
        return
      }

      update(() => {
        const needle = val.toLowerCase()
        this.list_desa = this.list_desa_master.filter(v =>
          v.nama_des_kel.toLowerCase().includes(needle)
        )
      })
    },


    addData() {
      this.btn_add = true;

      const formData = new FormData();

      for (let key in this.form) {
        if ((key === "file" || key === "file_spec") && this.form[key]) {
          formData.append(key, this.form[key]);
        } else if (key !== "file" && key !== "file_spec") {
          formData.append(key, this.form[key]);
        }
      }

      fetch(this.$store.state.url.KEGIATAN_CSR + "addData", {
        method: "POST",
        headers: {
          authorization: "kikensbatara " + localStorage.token
        },
        body: formData
      })
        .then(res => res.json())
        .then(res_data => {
          this.btn_add = false;
          if (res_data.success) {
            this.Notify("Sukses Menambah Data", "primary", "check_circle_outline");
            this.getView();
            this.mdl_add = false;
            this.resetForm();
          } else {
            this.Notify("Gagal Menambah Data", "negative", "error_outline");
          }
        })
        .catch(err => {
          this.btn_add = false;
          console.error("❌ Error:", err);
          this.Notify("Terjadi kesalahan server", "negative", "error_outline");
        });
    },
    resetForm() {
      this.form = {
        bidang_csr_id: null,
        bidang_sub_csr_id: null,
        nama_csr: "",
        deskripsi: "",
        jumlah: null,
        satuan: "",
        nilai: null,
        tanggal_mulai: "",
        tanggal_selesai: "",
        kecamatan_id: "",
        desa_id: "",
        alamat: ""
      }
    },


    editData() {
      if (!this.form.id) {
        this.Notify("ID data tidak ditemukan", "negative", "error_outline");
        return;
      }

      this.btn_add = true;

      const formData = new FormData();

      formData.append("id", this.form.id);
      for (let key in this.form) {
        if ((key === "file" || key === "file_spec") && this.form[key]) {
          formData.append(key, this.form[key]);
        } else if (!["file", "file_spec", "id"].includes(key)) {
          formData.append(key, this.form[key] ?? "");
        }
      }

      fetch(this.$store.state.url.KEGIATAN_CSR + "editData", {
        method: "POST",
        headers: {
          authorization: "kikensbatara " + localStorage.token
        },
        body: formData
      })
        .then(res => res.json())
        .then(res_data => {
          this.btn_add = false;
          if (res_data.success) {
            this.Notify("Sukses Mengubah Data", "primary", "check_circle_outline");
            this.mdl_edit = false;   // tutup modal edit (bukan add)
            this.getView();
          } else {
            this.Notify(res_data.message || "Gagal Mengubah Data", "negative", "error_outline");
          }
        })
        .catch(err => {
          this.btn_add = false;
          console.error("❌ Error editData:", err);
          this.Notify("Terjadi kesalahan server", "negative", "error_outline");
        });
    },


    getView() {
      this.$store.commit("shoWLoading")
      fetch(this.$store.state.url.KEGIATAN_CSR + "viewData", {
        method: "POST",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
        },
        body: JSON.stringify({
          ...this.filterku,
          data_ke: this.page_first,
          cari_value: this.cari_value,
          page_limit: this.page_limit
        })
      })
        .then(res => res.json())
        .then(res_data => {
          this.dataView = res_data.data
          this.total = res_data.total;
          this.page_last = Math.ceil(this.total / this.page_limit);
          this.$store.commit("hideLoading")
        })
        .catch(err => {
          console.error("❌ Error getView:", err)
          this.$store.commit("hideLoading")
        })
    },

    removeData: function () {
      const base = this.$store.state.url.KEGIATAN_CSR || '';
      const url = base.replace(/\/?$/, '/') + 'removeData';

      const payload = { id: this.form.id };

      fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": "kikensbatara " + localStorage.token
        },
        body: JSON.stringify(payload),
      })
        .then(async (res) => {
          const text = await res.text();
          let data; try { data = text ? JSON.parse(text) : {}; } catch { data = { message: text }; }
          if (!res.ok) throw new Error(data?.message || `HTTP ${res.status}`);
          return data;
        })
        .then((res_data) => {
          if (res_data?.success) {
            this.Notify(res_data.message || 'Sukses Menghapus Data', 'positive', 'check_circle_outline');
            this.getView();
          } else {
            this.Notify(res_data?.message || 'Gagal Menghapus Data', 'warning', 'error');
          }
        })
        .catch((err) => {
          this.Notify('Gagal menghapus: ' + (err.message || 'Unknown error'), 'warning', 'error');
        });
    },



    getBidangFilter() {
      fetch(this.$store.state.url.URL_DM_BID + "bidang", {
        headers: {
          authorization: "kikensbatara " + localStorage.token
        }
      })
        .then(res => res.json())
        .then(res_data => {
          this.bidangOptions = [
            { id: "", uraian: "-- SEMUA BIDANG --" },
            ...res_data.map(b => ({
              ...b,
              id: b.id.toString()  // pastikan tipe sama dengan v-model
            }))
          ];
        })
    },

    getSubBidangFilter() {
      this.filterku.bidang_sub_csr_id = null
      this.list_sub_bidang_filter = []

      if (!this.filterku.bidang_csr_id) return

      fetch(this.$store.state.url.URL_DM_BID + "sub_bidang", {
        method: "POST",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
        },
        body: JSON.stringify({
          bidang_csr_id: this.filterku.bidang_csr_id
        })
      })
        .then(res => res.json())
        .then(res_data => {
          this.list_sub_bidang_filter = res_data
        })
    },

    getKecamatanFilter() {
      fetch(this.$store.state.url.KEGIATAN_CSR + "kecamatan", {
        headers: {
          authorization: "kikensbatara " + localStorage.token
        }
      })
        .then(res => res.json())
        .then(res_data => {
          this.kecamatanOptions = [
            { kecamatan_id: "", nama_kecamatan: "-- SEMUA KECAMATAN --" },
            ...res_data.map(k => ({
              ...k,
              kecamatan_id: k.kecamatan_id.toString()
            }))
          ];
        })
        .catch(err => console.error("❌ Error fetch kecamatan:", err));
    },


    onChangeKecamatanFilter(val) {
      this.filterku.kecamatan_id = val;
      this.filterku.desa_id = "";
      this.getDesaFilter();
      this.getView();
    },


    getDesaFilter() {
      if (!this.filterku.kecamatan_id) {
        this.list_desa_filter = []
        return
      }

      fetch(this.$store.state.url.KEGIATAN_CSR + "desa", {
        method: "POST",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
        },
        body: JSON.stringify({
          kecamatan_id: this.filterku.kecamatan_id
        })
      })
        .then(res => res.json())
        .then(res_data => {
          this.list_desa_filter = res_data
        })
        .catch(err => {
          console.error("Error fetch desa:", err)
        })
    },



    Notify: function (message, positive, icon) {
      this.$q.notify({
        message: message,
        color: positive,
        icon: icon,
        position: 'top',
        timeout: 500,
      })
    },



    cari_data() {
      this.page_first = 1;
      this.getView();
    },


    async openEditModal(item) {
      this.selectedItem = item;


      this.form = {
        ...this.form,
        id: item.id,
        bidang_csr_id: item.bidang_csr_id ? String(item.bidang_csr_id) : null,
        bidang_sub_csr_id: item.bidang_sub_csr_id ? String(item.bidang_sub_csr_id) : null,
        nama_csr: item.nama_csr || "",
        deskripsi: item.deskripsi || "",
        jumlah: item.jumlah ?? null,
        satuan: item.satuan || "",
        nilai: item.nilai ?? null,
        tanggal_mulai: this.formatDateForInput(item.tanggal_mulai),
        tanggal_selesai: this.formatDateForInput(item.tanggal_selesai),
        kecamatan_id: item.kecamatan_id ? String(item.kecamatan_id) : null,
        desa_id: item.desa_id ? String(item.desa_id) : "",
        alamat: item.alamat || "",
        file: null,
        file_name: item.file_name || null
      };


      if (this.form.bidang_csr_id) {
        await this.getSubBidang(this.form.bidang_sub_csr_id);
      } else {
        this.list_sub_bidang = [];
      }


      await this.getDesaEdit(this.form.kecamatan_id, this.form.desa_id);


      this.mdl_edit = true;
    },

    getDesaEdit(kecamatan_id, presetDesaId) {
      this.form.desa_id = "";
      this.list_desa = [];
      this.list_desa_master = [];
      if (!kecamatan_id) return Promise.resolve();

      return fetch(this.$store.state.url.KEGIATAN_CSR + "desa", {
        method: "POST",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
        },
        body: JSON.stringify({ kecamatan_id })
      })
        .then(res => res.json())
        .then(res_data => {
          this.list_desa = res_data.map(d => ({
            ...d,
            des_kel_id: String(d.des_kel_id)
          }));
          this.list_desa_master = this.list_desa;
          if (presetDesaId) this.form.desa_id = presetDesaId;
        });
    },



  },
  mounted() {

    const get_profile = JSON.parse(localStorage.profile);
    this.tipe = Number(get_profile.profile.db_csrkonsel);


    this.mitra = {
      id: get_profile._id,
      nama: get_profile.profile.nama,
      username: get_profile.username
    }
    this.getView();
    this.getKecamatan();
    this.getKecamatanFilter();
    this.getBidang();
    this.getBidangFilter();

  }
}
